/** @file Describes the froented status String for backend entities Shift, Job, and SiteJob (not to be confused with
 * statuses used for accommodations).
 *
 * NOTE: backend entities actually represent the values with a boolean is_active column. The frontend performs the
 * conversion during service calls.  */

/** "Active" */
export const ACTIVE = 'Active';
/** "Inactive" */
export const INACTIVE = 'Inactive';
